export default function NotifBadge({
  children,
  show,
}: {
  children: React.ReactNode
  show: boolean
}) {
  return (
    <div className="relative">
      {children}
      {show && (
        <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full ring-2 ring-blue-600" />
      )}
    </div>
  )
}
